import state from './goldState'
import mutations from './goldMutations'
import actions from './goldActions'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
}
